import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class TitleService {

  private static Delimeter = ' > ';
  private appName: string;
  private pageTitle: string;

  constructor(private title: Title) {
  }

  public reset() {
    this.pageTitle = undefined;
    this.title.setTitle(this.appName);
  }

  public setAppName(baseTitle: string) {
    this.appName = baseTitle;
    this.title.setTitle(baseTitle);
  }

  public setPageTitle(title: string) {
    this.pageTitle = title;

    if (!title) {
      this.title.setTitle(this.appName);
    } else {
      this.title.setTitle([this.appName, title].join(TitleService.Delimeter));
    }
  }

  public getPageTitle(): string {
    return this.pageTitle;
  }
}
